import { getLocalItem } from '../util/util';
const state = {
  temporarilyToke: '',
  //后台管理
  adminToken: getLocalItem('adminToken') ? getLocalItem('adminToken') : null,
  adminName: getLocalItem('adminName') ? getLocalItem('adminName') : '',

  //客户商城
  clientName: getLocalItem('clientName') ? getLocalItem('clientName') : '',
  clientToken: getLocalItem('clientToken') ? getLocalItem('clientToken') : null,
  cartNum: 0,
  form_head_uuid:''
}

export default state;


// WEBPACK FOOTER //
// ./src/store/state.js